import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import Skeleton from 'react-loading-skeleton';
import { SkeletonWrapper } from './styled';
export function SkeletonComponent({ wrapperProps, skeletonProps, withWrapper = true, }) {
    if (withWrapper) {
        return (React.createElement(SkeletonWrapper, { ...wrapperProps },
            React.createElement(Skeleton, { ...skeletonProps })));
    }
    return React.createElement(Skeleton, { ...skeletonProps });
}
